import { DEFAULT_FILTERS_CONFIGURATION } from 'shared-constants/src/filters';
import { FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT } from 'shared-constants/src/filters/utils';

import isEqual from '../isEqual';

import {
  filterOldCategory,
  propTypeGroupRent,
  DEFAULT_FILTERS_VALUES,
} from './constants';

export const getFilterData = (name) => {
  let result = DEFAULT_FILTERS_CONFIGURATION[name];

  // Adding new keys in DEFAULT_FILTERS_CONFIGURATION seems to break MyCasa
  // So I'm gonna add this amazing check
  if (name === 'category-affitto-breve') {
    result = propTypeGroupRent;
  } else if (name === 'oldcategory') {
    result = filterOldCategory;
  }

  return result;
};

export const getDisplayValue = (filter, value) => {
  const filterData = getFilterData(filter) || {};
  const val = (filterData.values || []).filter((item) => item.value === value)[0];
  return val && val.display;
};

/**
 * Returns the values as a preview.
 * Used as previews in filter sections
 * @param {Object} filters Current selected filters
 * @param {String} filterName Filter name
 * @param {String} filterValue Current filter value
 * @returns {String}
 */
export const getPreviewFromFilters = (filters, filterName, filterValue) => {
  let result = getDisplayValue(filterName, filterValue);
  const { propertyTypes, channel } = filters;

  // Handle exceptions
  switch (filterName) {
    case 'category':
      if (channel === 'affitto-breve') {
        result = getDisplayValue('category-affitto-breve', filterValue);
      }

      if (propertyTypes.length === 1) {
        const [firstPropertyType] = propertyTypes;
        result = firstPropertyType;
      } else if (propertyTypes.length > 1) {
        result = propertyTypes.join(', ');
      }
      break;
    default:
  }

  return result;
};

export const computeActiveFilters = (filtersList) => {
  let activeFiltersCount = 0;
  const activeFiltersList = {};
  const includeFilters = ['q', 'pId'];

  Object.keys(filtersList).forEach(
    (filterName) => {
      if (filterName in DEFAULT_FILTERS_CONFIGURATION && filterName !== 'oldcategory') {
        const filterDefaultValue = DEFAULT_FILTERS_CONFIGURATION[filterName].defaultValue;
        switch (typeof filtersList[filterName]) {
          case 'string':
          case 'boolean':
            if (filtersList[filterName] !== filterDefaultValue) {
              activeFiltersList[filterName] = filtersList[filterName];
              if (FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT.indexOf(filterName) === -1) {
                activeFiltersCount += 1;
              }
            }
            break;
          default:
            if (!isEqual(filtersList[filterName], filterDefaultValue)) {
              activeFiltersList[filterName] = filtersList[filterName];
              if (FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT.indexOf(filterName) === -1) {
                activeFiltersCount += 1;
              }
            }
        }
      } else if (filterName.indexOf('Min') > -1 || filterName.indexOf('Max') > -1) {
        const isMin = filterName.indexOf('Min') > -1;
        const parentFilterName = filterName.replace('Min', '').replace('Max', '');
        if (parentFilterName in DEFAULT_FILTERS_CONFIGURATION) {
          if (isMin) {
            if (
              filtersList[`${parentFilterName}Min`] !== DEFAULT_FILTERS_CONFIGURATION[parentFilterName].defaultMinValue
            ) {
              activeFiltersList[`${parentFilterName}Min`] = filtersList[`${parentFilterName}Min`];
              activeFiltersCount += 1;
            }
          } else if (
            filtersList[`${parentFilterName}Max`] !== DEFAULT_FILTERS_CONFIGURATION[parentFilterName].defaultMaxValue
          ) {
            activeFiltersList[`${parentFilterName}Max`] = filtersList[`${parentFilterName}Max`];
            if (!(`${parentFilterName}Min` in activeFiltersList)) {
              activeFiltersCount += 1;
            }
          }
        }
      } else if (filterName === 'sortType' && filtersList[filterName] !== DEFAULT_FILTERS_VALUES.sortType) {
        activeFiltersList[filterName] = filtersList[filterName];
      } else if (includeFilters.includes(filterName)) {
        activeFiltersList[filterName] = filtersList[filterName];
      }
    },
  );

  if (filtersList.poi) {
    activeFiltersList.poi = filtersList.poi;
    activeFiltersCount += 1;
  }

  return {
    activeFiltersList,
    activeFiltersCount,
  };
};

export const hasSeoFilters = (filters) => {
  const filterskeys = [
    'garden',
    'balcony',
    'terrace',
    'heatingType',
    'lift',
    'numParkingSpaces',
    'only_auction',
    'availability',
    'has_swimming_pool',
  ];
  let withSeoFilters = false;
  Object.keys(filters).forEach((filter) => {
    if (filterskeys.includes(filter)) {
      withSeoFilters = true;
    }
  });
  return withSeoFilters;
};
